import { __awaiter, __generator } from "tslib";
import transFilter from 'vue-symfony-translator';
import { cmsActions, CookieHelper, coreActions, Coupons, customerActions, DestinationType, optimizelyActions, SearchFlowHelper, SearchMaskGroupType, store, UserSessionHelper, websiteActions } from 'ltur-state-engine';
import Vue from 'vue-ltur';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import { default as Calendar } from './Calendar';
import FilterHelper from "FilterBar/Helper/FilterHelper";
import localeAction from "Helper/localeAction";
import { STATE, StateHelper } from "Helper/StateHelper";
var inputValueSetupPromise = import('./InputValueSetup');
var productsPromise = import('../Helper/Products');
var StoreSetup = /** @class */ (function () {
    function StoreSetup() {
    }
    StoreSetup.initialApplicationSetup = function (contextObject) {
        var filterInitialized = false;
        var slugMapInitialized = false;
        var translationsInitialized = false;
        var couponInitialized = false;
        var thunkDispatch = store.dispatch;
        store.subscribe(function () { return setTimeout(function () {
            var state = store.getState();
            if (state.websiteState && state.websiteState.app && state.websiteState.app.url && state.websiteState.app.url.context) {
                if (state.coreState.package.formData && state.coreState.hotel.formData && !slugMapInitialized) {
                    slugMapInitialized = true;
                    var flatProductGroups = {
                        package: state.coreState.package.formData.flatProductGroups,
                        hotel: state.coreState.hotel.formData.flatProductGroups
                    };
                    // @ts-ignore
                    thunkDispatch(websiteActions.createRouteSlugMap(flatProductGroups, window.location));
                }
            }
            if (state.websiteState && state.websiteState.app && state.websiteState.app.currentStep && state.websiteState.app.url && state.websiteState.app.url.productQuery && !translationsInitialized) {
                translationsInitialized = true;
                thunkDispatch(websiteActions.getTranslations(window.location.protocol, contextObject.language));
            }
            if (state.websiteState.app.translations !== null && !filterInitialized) {
                filterInitialized = true;
                Vue.use(transFilter, {
                    language: contextObject.language,
                    translations: state.websiteState.app.translations
                });
                Vue.use(AirbnbStyleDatepicker, Calendar.getOptions());
                StateHelper.instance.resolveState(STATE.TRANSLATOR);
            }
            if (state.websiteState && state.websiteState.app && state.websiteState.app.translations && Coupons.isCouponForPageExist() && !couponInitialized) {
                couponInitialized = true;
                Coupons.prepareCouponStateAsync();
            }
        }, 0); });
        thunkDispatch(optimizelyActions.initializeOptimizelyTourOperatorCodes());
        thunkDispatch(websiteActions.setCurrentStep(window.location));
        thunkDispatch(websiteActions.setLocation(window.location));
        thunkDispatch(websiteActions.setUrlContext(window.location));
        thunkDispatch(websiteActions.setUrlQuery(window.location));
        setTimeout(function () {
            coreActions.getPackageFormData();
            coreActions.getHotelFormData();
        }, 0);
        thunkDispatch(websiteActions.getFosRoutes());
        this.initializeUser().then();
        Vue.mixin({
            data: function () {
                return {
                    lturState: store.getState(),
                };
            },
            mounted: function () {
                var _this = this;
                store.subscribe(function () { return setTimeout(function () {
                    _this.lturState = store.getState();
                }, 0); });
            },
        });
        setTimeout(function () {
            UserSessionHelper.initUserSession();
            CookieHelper.checkAndSetCookies();
        });
    };
    StoreSetup.initializeUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customerActions.loginOrCreateAnonymousUser()];
                    case 1:
                        _a.sent();
                        if (!(!window['loginActive'] && store.getState().customerState.user.authorities.includes("ROLE_USER"))) return [3 /*break*/, 3];
                        return [4 /*yield*/, customerActions.logout()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        StateHelper.instance.resolveState(STATE.USER_STATE);
                        return [4 /*yield*/, customerActions.getUserBookmarkInfo()];
                    case 4:
                        _a.sent();
                        StateHelper.instance.resolveState(STATE.BOOKMARK_INFORMATION);
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreSetup.initializeSearchMask = function () {
        var initialized = false;
        StoreSetup.loadCMSBlockSettings();
        store.subscribe(function () { return setTimeout(function () {
            var state = store.getState();
            if (!initialized
                && state.websiteState.app.translations
                && state.websiteState.app.url
                && state.websiteState.app.url.context
                && state.websiteState.searchMask.searchMaskBundle === null
                && state.coreState.package.formData
                && state.coreState.hotel.formData) {
                initialized = true;
                inputValueSetupPromise.then(function (module) {
                    setTimeout(function () {
                        var inputValueSetup = new module.default();
                        if (state.websiteState.searchMask.searchMaskActiveTab === SearchMaskGroupType.PACKAGE) {
                            inputValueSetup.initializePackage();
                        }
                        if (state.websiteState.searchMask.searchMaskActiveTab === SearchMaskGroupType.HOTEL) {
                            inputValueSetup.initializeHotel();
                        }
                        //StoreSetup.loadCMSBlockSettings();
                    }, 0);
                });
            }
        }, 0); });
    };
    StoreSetup.initializeBookmarkSearchMask = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inputValueSetup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        StoreSetup.loadCMSBlockSettings();
                        return [4 /*yield*/, new Promise(function (res) {
                                var unsubscribe = store.subscribe(function () { return setTimeout(function () {
                                    var state = store.getState();
                                    if (state.websiteState.app.translations
                                        && state.websiteState.app.url
                                        && state.websiteState.app.url.context
                                        && state.websiteState.searchMask.searchMaskBundle === null
                                        && state.coreState.package.formData
                                        && state.coreState.hotel.formData) {
                                        unsubscribe();
                                        res();
                                    }
                                }, 0); });
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, inputValueSetupPromise];
                    case 2:
                        inputValueSetup = new (_a.sent()).default();
                        inputValueSetup.initializeBookmark();
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreSetup.loadCMSBlockSettings = function () {
        var language = localeAction().language;
        if (!SearchFlowHelper.isSearchFlow(window.location.href)) {
            store.dispatch(cmsActions.getBlockSettings(window.location.protocol, window.location.pathname));
        }
        else {
            store.dispatch(cmsActions.getBlockSettings(window.location.protocol, "/" + language.toLowerCase() + "/index", false));
        }
    };
    StoreSetup.reloadAfterUrlChange = function (searchFlow) {
        if (searchFlow === void 0) { searchFlow = true; }
        var thunkDispatch = store.dispatch;
        thunkDispatch(websiteActions.setLocation(window.location));
        thunkDispatch(websiteActions.setUrlContext(window.location));
        thunkDispatch(websiteActions.setUrlQuery(window.location));
        thunkDispatch(websiteActions.getFosRoutes());
        var lturState = store.getState();
        StoreSetup.initializeSearchMask();
        var destinationType = FilterHelper.extractDestinationType(lturState);
        productsPromise.then(function (moduleProducts) {
            if (destinationType === DestinationType.HOTEL_LIST) {
                moduleProducts.default.getProductsAsync(DestinationType.HOTEL_LIST);
                moduleProducts.default.getGroupsAsync(DestinationType.HOTEL_LIST);
            }
            else {
                moduleProducts.default.getGroupsAsync(DestinationType.HOTEL_LIST);
            }
        });
    };
    return StoreSetup;
}());
export default StoreSetup;
